import { render } from "./CreatePayment.vue?vue&type=template&id=54dcec64&scoped=true"
import script from "./CreatePayment.vue?vue&type=script&lang=js"
export * from "./CreatePayment.vue?vue&type=script&lang=js"

import "./CreatePayment.vue?vue&type=style&index=0&id=54dcec64&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54dcec64"]])

export default __exports__